module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("For God is deaf nowadays and will not hear us")]), _vm._v(","), _c('br'), _c('em', [_vm._v("And for our guilt he grinds good men to dust")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("WILLIAM LANGLAND")]), _vm._v(","), _c('br'), _vm._v("Piers Ploughman")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("C’est le chemin qu’on appelle le Val d’ Enfer. Que votre Altesse me pardonne l’expression; je ne suis pas diable pour y passer")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MARSHAL VILLARS")]), _vm._v(","), _c('br'), _vm._v("regarding the Höllenthal, 1702")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b20f6c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780765340351_epub_prf1_r1.vue
// module id = 87
// module chunks = 0